import React, { Fragment, useState } from 'react';
import {useNotify, useRefresh } from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from '@material-ui/core';
import ButtonUI from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import { apiPost } from '../../brainApi';
import { trackFullStoryEvent } from '../../helper';

const BulkConfirmAppointment = ({ selectedIds }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [swIds, setSwIds] = useState([]);
  const numAppts = swIds.length;

  const handleOpen = () => {
    trackFullStoryEvent('CTA_Bulk_Confirm_Appointments_Click', {
      selected_count: selectedIds?.length || 0,
    });
    setSwIds(selectedIds);
    setOpen(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    trackFullStoryEvent('CTA_Bulk_Confirm_Appointments_Confirm', {
      num_appts: numAppts,
    });
    apiPost('/bulk-confirm-appointments', { swIds }).then((json) => {
      if (json.Status === 'Failure') {
        notify(`Error: ${json.Message}`, 'warning');
      } else {
        notify(
          `Successfully confirmed ${numAppts} appointment${
            numAppts > 1 ? 's' : ''
          }`,
        );
        refresh();
        setOpen(false);
        setSwIds([]);
      }
    });
  };

  return (
    <Fragment>
      <Button onClick={handleOpen} className="cancel_btn">
        Confirm Appointments
        <CheckIcon fontSize="small" />
      </Button>
      <Dialog open={open}>
        <DialogTitle>
          Are you sure you want to confirm {numAppts} appointment
          {numAppts > 1 ? 's' : ''}?
        </DialogTitle>
        <DialogContent>
          <Typography>
            This will update the status of selected appointments to "confirm".
          </Typography>
        </DialogContent>
        <DialogActions>
          <ButtonUI onClick={() => setOpen(false)} color="primary">
            Go Back
          </ButtonUI>
          <ButtonUI
            color="primary"
            variant="contained"
            onClick={(e) => handleSubmit(e)}
          >
            <CheckIcon style={{ marginRight: '7px' }} />
            Confirm
          </ButtonUI>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BulkConfirmAppointment;